import { z } from 'zod';

const KEY = /^[a-zA-Z0-9_]{1,40}$/;

/** Máximo de ids de linhas visíveis que a tela pode mandar (cabe no limite de 1 MB do pedido). */
export const EXPORT_IDS_MAX = 20000;

/** Colunas pedidas pela tela, na ordem dela, com o título já traduzido (ADR 0087). */
export const exportColumns = z
  .array(z.object({ key: z.string().regex(KEY), label: z.string().max(80) }))
  .min(1)
  .max(40);

/**
 * Exportação em Excel de uma lista (ADR 0087): os mesmos filtros da tela, as colunas escolhidas e,
 * se a tela quiser, o texto de cada código (ex.: situação "active" → "Ativo"), no idioma dela. O
 * servidor só aceita as colunas que a tela permite, e as sensíveis só para quem tem a permissão.
 * Quando o filtro é feito na própria tela, ela manda os ids das linhas visíveis (`ids`): o
 * servidor refaz a consulta da lista e só mantém essas linhas (nunca acrescenta nenhuma).
 */
export const exportInput = z.object({
  filters: z.record(z.string(), z.string().max(200)).default({}),
  columns: exportColumns,
  values: z
    .record(z.string().regex(KEY), z.record(z.string().max(60), z.string().max(80)))
    .refine((v) => Object.keys(v).length <= 40)
    .default({}),
  ids: z.array(z.uuid()).max(EXPORT_IDS_MAX).optional(),
});
export type ExportInput = z.infer<typeof exportInput>;
export type ExportColumnRequest = ExportInput['columns'][number];

/** Limite de linhas por exportação quando o servidor não define outro (EXPORT_MAX_ROWS). */
export const EXPORT_MAX_ROWS_DEFAULT = 10000;
